import { render, staticRenderFns } from "./IconAddFacture.vue?vue&type=template&id=746c6336&scoped=true&"
import script from "./IconAddFacture.vue?vue&type=script&lang=js&"
export * from "./IconAddFacture.vue?vue&type=script&lang=js&"
import style0 from "./IconAddFacture.vue?vue&type=style&index=0&id=746c6336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c6336",
  null
  
)

export default component.exports